( function () {
   
    'use strict';

    ( function ( $ ) {
        
        $('.popup-player-video').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
              open: function() {
                $("body").addClass("overflow");
                $(this.content).find('video')[0].play();
             },
              close: function() {
                $("body").removeClass("overflow");
                jQuery(this.content).find('video')[0].pause();
              }
            }
        });
    } )( jQuery );
} )();

